import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const pageElements = {
  init: function() {
    var options = {
      infinite: true,
      autoplay: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            infinite: false,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            infinite: false,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            infinite: false,
            slidesToShow: 1,
          },
        },
      ],
    };

    function processTitle(title) {
      // Check if the title contains the pipe character '|'
      if (!title.includes('|')) {
        return null; // Return null if the pipe character doesn't exist
      }

      // Since we know the pipe exists, split the title at the pipe character and trim
      let processedTitle = title.split('|')[1].trim();

      // Split the processed title into two parts based on the first whitespace
      let titlesplit = processedTitle.match(/^(\S+)\s(.*)/);

      if (titlesplit && titlesplit.length > 1) {
        // Extract the parts and return them
        return { part1: titlesplit[1], part2: titlesplit[2] };
      }

      // If the title doesn't have two parts after the pipe, return null or an indication of no processing needed
      return null;
    }

    // $('.js-product-sliderHome1').slick(options);

    //Re call function for home page slider under the main banner

    // if ($('.js-product-sliderHome1')[0]) {
    //   var hmtarget = document.querySelector('.js-product-sliderHome1');
    //   var hmobserver = new MutationObserver(function(mutations) {
    //     //$('.js-product-sliderHome1').slick('reinit');
    //     // if (!$('.js-product-sliderHome1').hasClass('slick-initialized')) {
    //     //   $('.js-product-sliderHome1').slick('unslick');
    //     // }

    //     $('.js-product-sliderHome1').on('init', function(event, slick) {
    //       $('.js-product-sliderHome1 .slick-slide').each(function(index, slide) {
    //         let titleEl = $(slide).find('.product-card__title a');
    //         if (titleEl.length > 0) {
    //           let title = titleEl.text();
    //           let processed = processTitle(title);

    //           if (processed) {
    //             let titleHTML = `${processed.part2}`;
    //             titleEl.html(titleHTML);
    //           }
    //         }
    //       });
    //     });

    //     $('.js-product-sliderHome1').slick(options);

    //     hmobserver.disconnect();
    //   });
    //   var hmconfig = { attributes: true, childList: true, characterData: true };
    //   hmobserver.observe(hmtarget, hmconfig);
    // }
    //reservation area
    if ($('.reserve__area')[0]) {
      var rtarget = document.querySelector('.reserve__area');
      var robserver = new MutationObserver(function(mutations) {
        $('#c7-guestCount option:eq(0)').text('No of Guests');
        $('#c7-reservationTime option:eq(0)').text('Reservation Time');
        $('.c7-search-tools--Date .date-picker input').attr('placeholder', 'Reservation Date');

        robserver.disconnect();
      });
      var rconfig = { attributes: true, childList: true, characterData: true };
      robserver.observe(rtarget, rconfig);
    }

    function imageappend(data, item) {
      var imageclass = '.shop_item_mine_referance .image .proimage' + item;
      var image = $(imageclass).attr('src');
      var html = '<div class="shop-prdt-listing__image-wrap"><figure> <img src="' + image + '" alt="ProductList Image"></figure></div>';
      $(data).after(html);
    }

    let count4Flag = true;
    let count7Flag = true;

    function collectionFilterSetup() {
      $('.shop-prdt-listing__item').each(function(index) {
        //console.log( index + ": " + $( this ).text() );
        var count = index + 1;
        $(this).addClass('valuereader');
        $(this).addClass('item' + count);
        var bottle = $('.valuereader .filt .size').html();
        var varity = $('.valuereader .filt .variety').html();
        let titleEl = $(this).find('.product-card__title a');
        if (bottle) {
          $('.valuereader').addClass(bottle.toLowerCase().replace(/\s+/g, ''));
        }

        if (titleEl.length > 0) {
          let title = titleEl.text();
          let processed = processTitle(title);

          if (processed) {
            let titleHTML = `${processed.part2}`;
            titleEl.html(titleHTML);
          }
        }

        if (varity) {
          var items = varity.split(',');
          $.each(items, function(i) {
            //alert(items[i]);
            $('.valuereader').addClass(items[i].toLowerCase().replace(/\s+/g, ''));
          });
        }
        $(this).removeClass('valuereader');

        if ((count == 4) & count4Flag) {
          count4Flag = false;
          imageappend('.item' + count, 1);
        }

        if ((count == 7) & count7Flag) {
          count7Flag = false;
          imageappend('.item' + count, 2);
        }

        var numItems = $('.product-card--pc-list:visible').length;
        if (numItems == 0) {
          $('.noitemsav').remove();
          $('.shop-prdt-listing__wrap').append('<p class="noitemsav" class="no__items__visible">No items available</p>');
        } else {
          $('.noitemsav').remove();
        }
      });
    }

    if ($('.profilter')[0]) {
      var target = document.querySelector('.profilter');
      var observer = new MutationObserver(function(mutations) {
        collectionFilterSetup();

        observer.disconnect();
      });
      var config = { attributes: true, childList: true, characterData: true };
      observer.observe(target, config);

      setTimeout(function() {
        collectionFilterSetup();
      }, 3000);
    }

    if (document.contains(document.querySelector('.page-template-shop-with-filer'))) {
      $(window).on('load', function() {
        setTimeout(function() {
          collectionFilterSetup();
          console.log('collectionFilter ');
        }, 5000);
      });
    }

    //gift offering animation
    if ($('.giftm')[0]) {
      var gifttarget = document.querySelector('.giftm');
      var giftobserver = new MutationObserver(function(mutations) {
        if ($('.shop-gift-offerings__wrap').length > 0) {
          var elm = $('.shop-gift-offerings__item:odd');
          elm.each(function() {
            var tl = gsap.timeline({
              scrollTrigger: {
                trigger: $(this),
                endTrigger: $(this),
                start: 'top bottom',
                // markers: true,
                scrub: true,
              },
            });
            tl.to($(this), { y: 100 });
          });
        }
        giftobserver.disconnect();
      });
      var giftconfig = { attributes: true, childList: true, characterData: true };
      giftobserver.observe(gifttarget, giftconfig);

      var itemc = $('.shop-gift-offerings__item').length;
      if (itemc == 0) {
        $('.shop-gift-offerings .container').hide();
      }
    }

    //collection page
    if ($('.product__collections')[0]) {
      $('#wp__page__title').html('');
      var collectiontarget = document.querySelector('.product__collections');
      var collectionobserver = new MutationObserver(function(mutations) {
        $('#c7-content section').addClass('prd-collection__list');
        var titles = $('#c7-content section h1').text();
        $('#wp__page__title').html();
        if (titles) {
          $('#c7-content section h1').remove();
          $('#wp__page__title').html(titles);
          // $('.product__collections')
          //   .find('div')
          //   .first()
          //   .remove();
          // $('.prd-collection__list')
          //   .contents()
          //   .unwrap();
          // $('.c7-product-collection')
          //   .contents()
          //   .unwrap();
          // collectionobserver.disconnect();
          // var numItems = $('.product-card--pc-list:visible').length;
          // if (numItems == 0) {
          //   $('.noitemsav').remove();
          //   $('.shop-prdt-listing__wrap').append('<p class="noitemsav" class="no__items__visible">No items available</p>');
          // } else {
          //   $('.noitemsav').remove();
          // }
        }
        $('body').on('click', '.product-card--pc-list figure a', function(event) {
          event.preventDefault();
          location.reload();
        });
      });
      var collectionconfig = { attributes: true, childList: true, characterData: true };
      collectionobserver.observe(collectiontarget, collectionconfig);
    }

    //product detail page image change
    if ($('.product__area__mine').length) {
      let target = document.querySelector('.product__area__mine');
      let observer = new MutationObserver(function(mutations) {
        let titleElement = document.querySelector('.pruduct-details-sec__title-sec h4');
        if (titleElement) {
          let title = titleElement.innerHTML.trim();
          // Check if the title contains the pipe character '|'
          if (title.includes('|')) {
            // Split the title at the pipe character and use the part after it
            title = title.split('|')[1].trim();
          }
          let titlesplit = title.match(/^(\S+)\s(.*)/).slice(1);
          if (titlesplit.length > 1) {
            let titleHTML = `<h4>${titlesplit[0]}</h4><h2>${titlesplit[1]}</h2>`;
            $('.pruduct-details-sec__title-sec').html(titleHTML);
          }
        }

        let datElement = $('.right-sec .notvisible .tasting div');
        if (datElement.length) {
          let items = datElement.html().split('|');
          items.forEach((item) => {
            let [image, title] = item.split('---');
            if (image && title) {
              let html = `<div class="tasting-item"><img src="${image}" alt="image"><span class="tasting-title">${title}</span></div>`;
              $('.product-details-tasting__wrap .right-sec').append(html);
            }
          });
        }

        let datsElement = $('.right-sec .notvisible .points div');
        if (datsElement.length) {
          $('.no__accolade__for_this__item').removeClass('no__accolade__for_this__item');
          let items = datsElement.html().split('|');
          items.forEach((item) => {
            let parts = item.split('---');
            if (parts.length >= 3) {
              let [image, score, description] = parts;
              let s = score ? score.match(/^(\S+)\s(.*)/).slice(1) : ['', ''];
              let html = `<div class="accolade-item"><figure><img src="${image}" alt="image"></figure><h2>${s[0]} <span>${s[1]}</span></h2><p>${description}</p></div>`;
              $('.product-details-accolade__wrap').append(html);
            }
          });
        } else {
          $('.product-details-accolade__wrap').addClass('no__accolade__for_this__item');
        }

        if ($('.product-details-accolade__wrap').length && $('.accolade-item').length > 2) {
          let elms = $('.accolade-item:odd');
          elms.each(function() {
            let tl = gsap.timeline({
              scrollTrigger: {
                trigger: $(this),
                endTrigger: $(this),
                start: 'top bottom',
                scrub: true,
              },
            });
            tl.to($(this), { y: -100 });
          });
        }

        $('#countbox').prop('type', 'number'); // Assuming this is the intended functionality

        let js_link = $('.pro_pdf_link').html();
        if (js_link) {
          $('.js__link__pdf').attr('href', js_link);
        }

        let lifeder = $('.lifeimage').html();
        if (lifeder) {
          $('.life__maper img').attr('src', lifeder);
          $('.life__maper img').attr('srcset', lifeder);
        }
      });

      let config = { attributes: true, childList: true, characterData: true };
      observer.observe(target, config);
    }

    //$('body').on('click', '.test', function(){
    //document.getElementById('countbox').stepUp();
    // $('#countbox').attr('value',3);

    //});

    //filter chnage
    $('body').on('change', '.filter-item select', function() {
      var ver = $('#filter-variety').val();
      var size = $('#filter-bottle-size').val();
      $('.shop-prdt-listing__image-wrap').hide();
      $('.shop-prdt-listing__item').each(function(index) {
        if (ver) {
          if (size) {
            if ($(this).hasClass(ver) && $(this).hasClass(size)) {
              $(this).fadeIn();
            } else {
              $(this).hide();
            }
          } else {
            if ($(this).hasClass(ver)) {
              $(this).fadeIn();
            } else {
              $(this).hide();
            }
          }
        }
        if (size) {
          if (ver) {
            if ($(this).hasClass(ver) && $(this).hasClass(size)) {
              $(this).fadeIn();
            } else {
              $(this).hide();
            }
          } else {
            if ($(this).hasClass(size)) {
              $(this).fadeIn();
            } else {
              $(this).hide();
            }
          }
        }
        if (ver == '' && size == '') {
          $(this).fadeIn();
          $('.shop-prdt-listing__image-wrap').fadeIn();
        }
      });

      var numItems = $('.product-card--pc-list:visible').length;
      if (numItems == 0) {
        $('.noitemsav').remove();
        $('.shop-prdt-listing__wrap').append('<p class="noitemsav" class="no__items__visible">No items available</p>');
      } else {
        $('.noitemsav').remove();
      }
    });

    // Top cart update
    const cartObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          const count = $('.c7-user-nav__cart__count').html();
          $('.cart-number').html(count);
        }
      });
    });

    const cartConfig = { childList: true, subtree: true };
    const cartTarget = document.querySelector('.minicart');
    if (cartTarget) {
      cartObserver.observe(cartTarget, cartConfig);
    }

    // Default page content update
    const pageContentObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          const tit = $('.default-page #c7-content h1').text();
          if (tit) {
            $('#wp__page__title').html(tit);
            $('.default-page #c7-content h1').hide();
          }
        }
      });
    });

    const pageContentConfig = { childList: true, subtree: true };
    const pageContentTarget = document.querySelector('.default-page #c7-content');
    if (pageContentTarget) {
      pageContentObserver.observe(pageContentTarget, pageContentConfig);
    }

    //top cart click
    $('body').on('click', '.menu-btn--cart', function() {
      $('#c7-cart .c7-user-nav__cart > button').trigger('click');
    });

    //news letter submission and validation
    // $('.newsletter').submit(function(event) {
    //   event.preventDefault();
    //   var $form = $(this);
    //   var id = $form.attr('id');
    //   var sub = '#' + id;

    //   var fnamec = $(sub + ' .fname');
    //   var lnamec = $(sub + ' .lname');
    //   var emailc = $(sub + ' .email');

    //   var fname = $(fnamec).val();
    //   var lname = $(lnamec).val();
    //   var email = $(emailc).val();

    //   var error = 0;

    //   if (fname == '') {
    //     $(fnamec).addClass('input__error');
    //     error = 1;
    //   } else {
    //     var cc = /^[0-9-+]+$/;
    //     if (cc.test(fname)) {
    //       $(fnamec).addClass('input__error');
    //       error = 1;
    //     } else {
    //       $(fnamec).removeClass('input__error');
    //     }
    //   }

    //   if (lname == '') {
    //     $(lnamec).addClass('input__error');
    //     error = 1;
    //   } else {
    //     var cc = /^[0-9-+]+$/;
    //     if (cc.test(lname)) {
    //       $(lnamec).addClass('input__error');
    //       error = 1;
    //     } else {
    //       $(lnamec).removeClass('input__error');
    //     }
    //   }

    //   if (email == '') {
    //     $(emailc).addClass('input__error');
    //     error = 1;
    //   } else {
    //     var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    //     if (filter.test(email)) {
    //       $(emailc).removeClass('input__error');
    //     } else {
    //       $(emailc).addClass('input__error');
    //       error = 1;
    //     }
    //   }
    //   if (error != 1) {
    //     $('.nonvsible .newsletter #c7-firstName')
    //       .focus()
    //       .attr('value', fname);
    //     $('.nonvsible .newsletter #c7-lastName')
    //       .focus()
    //       .attr('value', lname);
    //     $('.nonvsible .newsletter #c7-email')
    //       .focus()
    //       .attr('value', email);
    //     var da = $('.nonvsible .newsletter #c7-firstName').val();
    //     if (da) {
    //       $('.nonvsible .newsletter .c7-button')
    //         .focus()
    //         .trigger('click');
    //       let mList = document.querySelector('.c7-subscribe'),
    //         options = { childList: true },
    //         observer = new MutationObserver(mCallback);
    //       function mCallback(mutations) {
    //         for (let mutation of mutations) {
    //           if (mutation.type === 'childList') {
    //             var title = $('.c7-subscribe-message h3').text();
    //             var message = $('.c7-subscribe-message p').text();

    //             $('.news__letter__area #form__sucess').remove();
    //             $('.newsletter').after('<div id="form__sucess" class="form__sucess"><h5>' + title + '</h5><p>' + message + '</p></div>');
    //             $('.newsletter').hide();
    //             observer.disconnect();
    //           }
    //         }
    //       }
    //       observer.observe(mList, options);
    //     } else {
    //     }
    //   }
    // });

    //creating cookie
    function createCookie(name, value, days) {
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
      }
      document.cookie = name + '=' + value + expires + '; path=/';
    }
    //reading cookie
    function readCookie(name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    //cookie settings on click
    $('body').on('click', '.cookies', function(event) {
      event.preventDefault();
      var url = $('.cookies').attr('href');
      createCookie('page-intro', 'yes', 1);
      if (readCookie('page-intro') === 'yes') {
        window.location.href = url;
      }

      //var url = $('.cookies').attr('href');
      //var ajax_url = plugin_ajax_object.ajax_url;
      //var data = {
      //    'action'  : 'setckies',
      //};

      // $.ajax({
      //  url: ajax_url,
      //  type: 'post',
      //  data: data,
      //  dataType: 'json',
      //  success: function(response){
      //    window.location.href=url;
      //  },
      //  error: function(xhr, status, error) {
      //  }
      //});
    });

    var eventslideoptions = {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 990,
          settings: 'unslick',
        },
      ],
    };

    //upcoming evnets list tab click for desktop
    $('body').on('click', '.desktop__upcoming__list .upevents .event-nav__item a', function(event) {
      event.preventDefault();
      $('.desktop__upcoming__list .upevents a.active').removeClass('active');
      $(this).addClass('active');
      $('.desktop__upcoming__list .upcoming__loader a').attr('data-page', '0');
      $('.desktop__upcoming__list .upcoming__loader').show();
      $('.desktop__upcoming__list .upcoming__wrap .event-list__item').remove('');
      $('.desktop__upcoming__list .upcoming__loader a').trigger('click');
    });

    //load more click event in desktop
    $('body').on('click', '.upcoming__loader a', function(event) {
      event.preventDefault();
      $('.desktop__upcoming__list .event-list_loader').show();
      var page = $(this).attr('data-page');
      var active = $('.desktop__upcoming__list .upevents .active').attr('data-type');

      var ajax_url = plugin_ajax_object.ajax_url;
      var data = {
        action: 'more_events',
        type: 'up',
        page: page,
        event: active,
        dev: 'desk',
      };
      $.ajax({
        url: ajax_url,
        type: 'post',
        data: data,
        dataType: 'json',
        success: function(response) {
          $('.desktop__upcoming__list .event-list_loader').hide();
          $('.desktop__upcoming__list .upcoming__wrap').append(response.html);
          var numItems = $('.desktop__upcoming__list .upcoming__wrap .event-list__item').length;
          if (numItems == response.count) {
            $('.desktop__upcoming__list .upcoming__loader').hide();
          } else {
            page = +page + 1;
            $('.desktop__upcoming__list .upcoming__loader a').attr('data-page', page);
          }
        },
        error: function(xhr, status, error) {
          alert(error);
        },
      });
    });

    //tab click event on mobile version
    $('body').on('click', '.mobile__upcoming__list .upevents .event-nav__item a', function(event) {
      event.preventDefault();
      $('.mobile__upcoming__list .upevents a.active').removeClass('active');
      $(this).addClass('active');
      var active = $('.mobile__upcoming__list .upevents .active').attr('data-type');
      var ajax_url = plugin_ajax_object.ajax_url;
      var data = {
        action: 'more_events',
        type: 'up',
        event: active,
      };
      $.ajax({
        url: ajax_url,
        type: 'post',
        data: data,
        dataType: 'json',
        success: function(response) {
          $('.mobile__upcoming__list .upcoming__wrap').slick('unslick');
          $('.mobile__upcoming__list .upcoming__wrap .event-list__item').remove('');
          $('.mobile__upcoming__list .upcoming__wrap').append(response.html);
          $('.mobile__upcoming__list .upcoming__wrap').slick(eventslideoptions);
        },
        error: function(xhr, status, error) {
          alert(error);
        },
      });
    });

    //past event list for desktop
    $('body').on('click', '.desktop__past__list .pastevents .event-nav__item a', function(event) {
      event.preventDefault();
      $('.desktop__past__list .pastevents a.active').removeClass('active');
      $(this).addClass('active');
      $('.desktop__past__list .past__loader a').attr('data-page', '0');
      $('.desktop__past__list .past__loader').show();
      $('.desktop__past__list .past__wrap .event-list__item').remove('');
      $('.desktop__past__list .past__loader a').trigger('click');
    });

    $('body').on('click', '.desktop__past__list .past__loader a', function(event) {
      event.preventDefault();
      $('.desktop__past__list .event-list_loader').show();
      var page = $(this).attr('data-page');
      var active = $('.desktop__past__list .pastevents .active').attr('data-type');

      var ajax_url = plugin_ajax_object.ajax_url;
      var data = {
        action: 'more_events',
        type: 'past',
        page: page,
        event: active,
        dev: 'desk',
      };
      $.ajax({
        url: ajax_url,
        type: 'post',
        data: data,
        dataType: 'json',
        success: function(response) {
          $('.desktop__past__list .event-list_loader').hide();
          $('.desktop__past__list .past__wrap').append(response.html);
          var numItems = $('.desktop__past__list .past__wrap .event-list__item').length;
          if (numItems == response.count) {
            $('.desktop__past__list .past__loader').hide();
          } else {
            page = +page + 1;
            $('.desktop__past__list .past__loader a').attr('data-page', page);
          }
        },
        error: function(xhr, status, error) {
          alert(error);
        },
      });
    });

    //tab click past event on mobile version
    $('body').on('click', '.mobile__past__list .pastevents .event-nav__item a', function(event) {
      event.preventDefault();
      $('.mobile__past__list .pastevents a.active').removeClass('active');
      $(this).addClass('active');
      var active = $('.mobile__past__list .pastevents .active').attr('data-type');
      var ajax_url = plugin_ajax_object.ajax_url;
      var data = {
        action: 'more_events',
        type: 'up',
        event: active,
      };
      $.ajax({
        url: ajax_url,
        type: 'post',
        data: data,
        dataType: 'json',
        success: function(response) {
          $('.mobile__past__list .past__wrap').slick('unslick');
          $('.mobile__past__list .past__wrap .event-list__item').remove('');
          $('.mobile__past__list .past__wrap').append(response.html);
          $('.mobile__past__list .past__wrap').slick(eventslideoptions);
        },
        error: function(xhr, status, error) {
          alert(error);
        },
      });
    });

    // specific tab click in event page
    if ($('.upevents')[0]) {
      function eclick() {
        var hash = window.location.hash.substr(1);
        if (hash) {
          var cl = '.' + hash;
          $(cl).trigger('click');
        }
      }
      eclick();
      $(window).on('hashchange', function(e) {
        eclick();
      });
    }

    // specific tab click in club page
    if ($('.club__slider')[0]) {
      function bclick() {
        var hash = window.location.hash.substr(1);
        if (hash) {
          var cl = '.club__slider #' + hash;
          $(cl).trigger('click');
        }
      }
      bclick();
      $(window).on('hashchange', function(e) {
        bclick();
      });
    }

    //loade all faq in wine club page
    if ($('.wine-club-faq__btn-wrap')[0]) {
      $('body').on('click', '.wine-club-faq__btn-wrap a', function(event) {
        event.preventDefault();
        $('.accordion__wrap .non-vsible')
          .addClass('yes-visible')
          .removeClass('non-vsible');
        $('.wine-club-faq__wrap').removeClass('non-vsible');
        $(this).hide();
      });
    }

    //pringting module
    function printDiv(divName) {
      var printContents = document.getElementById(divName).innerHTML;
      w = window.open();
      w.document.write(printContents);
      w.print();
      w.close();
    }

    //share more button click
    if ($('.sharethis-inline-share-buttons')[0]) {
      $('body').on('click', '.share__button__more', function(event) {
        event.preventDefault();
        $('#st-1 img').trigger('click');
        $('.st-logo').remove();
        $('.st-disclaimer').remove();
      });
    }

    // click on close when mobile menu
    $('body').on('click', '.mob__mover a', function(event) {
      if ($('.header__mobile-menu').hasClass('active')) {
        $('.header__mobile-menu').trigger('click');
      }
    });

    //scroll to animation
    function scrollup(loc, data) {
      if (!document.querySelector(loc)) return;
      $('html,body').animate(
        {
          scrollTop: $('#' + loc).offset().top - data,
        },
        1000
      );
    }

    function scrolldown(loc, data) {
      if (!document.querySelector(loc)) return;

      $('html,body').animate(
        {
          scrollTop: $('#' + loc).offset().top + data,
        },
        1000
      );
    }

    function scrollto(loc) {
      if (!document.querySelector(loc)) return false;

      $('html,body').animate(
        {
          scrollTop: $('#' + loc).offset().top,
        },
        1000
      );
    }

    //scroll on #value in pages
    $(window).on('load', function() {
      var urlHash = window.location.href.split('#')[1];
      if (urlHash == 'benefits') {
        scrollup(urlHash, 100);
      } else {
        scrollto(urlHash);
      }
    });

    $('body').on('click', '#hash', function(event) {
      var urlHash = window.location.href.split('#')[1];
      scrollup(urlHash, 100);
    });

    //scroll on #value in pages
    $(window).on('hashchange', function() {
      var urlHash = window.location.href.split('#')[1];
      if (urlHash == 'benefits') {
        scrollup(urlHash, 100);
      } else {
        scrollto(urlHash);
      }
    });

    //map in contact form
    if ($('.my__maps')[0]) {
      $('.my__maps').each(function(index) {
        $(this).addClass('dataread');
        var lats = $('.dataread .infowindow').data('lat');
        var lngs = $('.dataread .infowindow').data('lng');
        var ids = $('.dataread .map-container').attr('id');
        var myLatLng = { lat: lats, lng: lngs };

        var mpt = $('.dataread .google__map__title__get').text();
        var mpa = $('.dataread .google__map__content__get').text();
        var mpd = $('.dataread .google__map__direction__get').attr('href');

        $(this).removeClass('dataread');
        var mapoptions = {
          center: myLatLng,
          zoom: 12,
          gestureHandling: 'none',
          zoomControl: false,
          styles: [
            {
              featureType: 'water',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#e9e9e9',
                },
                {
                  lightness: 17,
                },
              ],
            },
            {
              featureType: 'landscape',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#f5f5f5',
                },
                {
                  lightness: 20,
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#ffffff',
                },
                {
                  lightness: 17,
                },
              ],
            },
            {
              featureType: 'road.highway',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#ffffff',
                },
                {
                  lightness: 29,
                },
                {
                  weight: 0.2,
                },
              ],
            },
            {
              featureType: 'road.arterial',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#ffffff',
                },
                {
                  lightness: 18,
                },
              ],
            },
            {
              featureType: 'road.local',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#ffffff',
                },
                {
                  lightness: 16,
                },
              ],
            },
            {
              featureType: 'poi',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#f5f5f5',
                },
                {
                  lightness: 21,
                },
              ],
            },
            {
              featureType: 'poi.park',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#dedede',
                },
                {
                  lightness: 21,
                },
              ],
            },
            {
              elementType: 'labels.text.stroke',
              stylers: [
                {
                  visibility: 'on',
                },
                {
                  color: '#ffffff',
                },
                {
                  lightness: 16,
                },
              ],
            },
            {
              elementType: 'labels.text.fill',
              stylers: [
                {
                  saturation: 36,
                },
                {
                  color: '#333333',
                },
                {
                  lightness: 40,
                },
              ],
            },
            {
              elementType: 'labels.icon',
              stylers: [
                {
                  visibility: 'off',
                },
              ],
            },
            {
              featureType: 'transit',
              elementType: 'geometry',
              stylers: [
                {
                  color: '#f2f2f2',
                },
                {
                  lightness: 19,
                },
              ],
            },
            {
              featureType: 'administrative',
              elementType: 'geometry.fill',
              stylers: [
                {
                  color: '#fefefe',
                },
                {
                  lightness: 20,
                },
              ],
            },
            {
              featureType: 'administrative',
              elementType: 'geometry.stroke',
              stylers: [
                {
                  color: '#fefefe',
                },
                {
                  lightness: 17,
                },
                {
                  weight: 1.2,
                },
              ],
            },
          ],
        };
        var dir = '';
        if (mpd) {
          dir = '<a target="_blank" href="' + mpd + '">Directions</a>';
        }
        var map = new google.maps.Map(document.getElementById(ids), mapoptions);
        var marker = new google.maps.Marker({ position: myLatLng, map });
        var infowindow = new google.maps.InfoWindow({
          content: '<div class=google__map__infowindow><h4>' + mpt + '</h4><p>' + mpa + '<br>' + dir + '</p></div>',
        });
        google.maps.event.addListener(marker, 'click', function() {
          infowindow.open(map, marker);
        });
      });
    }

    //map sliding option in vineyards
    function loadmaptab(divName) {
      var map = '#' + divName;
      if (!$('.image-map-wrap__main').hasClass('inactive')) {
        $('.image-map-wrap__sub').addClass('active');
        $(map).addClass('active');
        setTimeout(function() {
          $('.image-map-wrap__main').addClass('inactive');
          $('.mob-back-btn-wrap').addClass('inactive');
          $(map).addClass('animate');
          $('.imp-tooltip-visible').removeClass('imp-tooltip-visible');
        }, 100);
      }
    }

    window.loadmaptab = loadmaptab;

    //map slide back in vineyards
    $('body').on('click', '.inactive', function(event) {
      if ($(this).hasClass('inactive')) {
        $('.image-map-wrap__main').removeClass('inactive');
        $('.mob-back-btn-wrap').removeClass('inactive');
        $('.image-map-wrap__sub').removeClass('active');
        setTimeout(function() {
          $('.image-map').removeClass('active');
        }, 200);
      }
    });

    //changing the div inside the map pop in vineyards
    function mapitemchanger() {
      $('.primmap .squares-element').each(function(index) {
        if (index == 0) {
          $(this).addClass('first__content_section');
        } else if (index == 1) {
          $(this).addClass('second__content_section');
        } else {
          var data = $(this).html();
          $('.second__content_section').append(data);
          $(this).remove();
        }
      });
    }
    //map area
    if ($('.image-map-wrap__sub')[0]) {
      $('body').on('click', '.image-map-wrap__sub .image-map .imp-shape-spot-pin', function(event) {
        setTimeout(function() {
          var items = $('.imp-tooltip-visible .squares-container').length;
          if (items > 1) {
            $('.imp-tooltip-visible .squares-container:visible').each(function(index) {
              console.log(index + ': ' + $(this).text());
              if (index == 0) {
                $(this).addClass('primmap');
              } else {
                var html = $(this).html();
                $('.primmap').append(html);
                $(this).remove();
              }
            });
            mapitemchanger();
          } else {
            $('.imp-tooltip-visible .squares-container').addClass('primmap');
            mapitemchanger();
          }
        }, 20);
      });
    }
    $('body').on('click', '.imp-tooltip-close-button', function(event) {
      $('.primmap').removeClass('primmap');
      $('.first__content_section').removeClass('first__content_section');
      $('.second__content_section').removeClass('second__content_section');
    });

    //escape button click
    $(document).on('keydown', function(event) {
      if (event.key == 'Escape') {
        if ($('.imp-tooltip-close-button').is(':visible')) {
          $('.imp-tooltip-close-button').trigger('click');
        }
        if ($('.extra__map__closer').is(':visible')) {
          $('.inactive').trigger('click');
        }
      }
    });

    $('body').on('click', '.extra__map__closer', function(event) {
      $('.inactive').trigger('click');
    });

    function extendMagnificIframe() {
      var $start = 0;
      var $iframe = {
        markup:
          '<div class="mfp-iframe-scaler">' +
          '<div class="mfp-close"></div>' +
          '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
          '</div>' +
          '<div class="mfp-bottom-bar">' +
          '<div class="mfp-title"></div>' +
          '</div>',
        patterns: {
          youtube: {
            index: 'youtu',
            id: function(url) {
              var m = url.match(/^.*(?:youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/);
              if (!m || !m[1]) return null;

              if (url.indexOf('t=') != -1) {
                var $split = url.split('t=');
                var hms = $split[1]
                  .replace('h', ':')
                  .replace('m', ':')
                  .replace('s', '');
                var a = hms.split(':');

                if (a.length == 1) {
                  $start = a[0];
                } else if (a.length == 2) {
                  $start = +a[0] * 60 + +a[1];
                } else if (a.length == 3) {
                  $start = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
                }
              }

              var suffix = '?autoplay=1';

              if ($start > 0) {
                suffix = '?start=' + $start + '&autoplay=1';
              }

              return m[1] + suffix;
            },
            src: '//www.youtube.com/embed/%id%',
          },
          vimeo: {
            index: 'vimeo.com/',
            id: function(url) {
              var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
              if (!m || !m[5]) return null;
              return m[5];
            },
            src: '//player.vimeo.com/video/%id%?autoplay=1',
          },
        },
      };

      return $iframe;
    }

    //video pop in app pages
    $(document).ready(function() {
      $('.js-popup--video').magnificPopup({
        type: 'iframe',
        enableEscapeKey: true,
        iframe: extendMagnificIframe(),
      });
    });

    //select box tick options in experice single page
    if ($('.choose-item__wrap')[0]) {
      $('.parret__butt').click(function() {
        if ($(this).is(':checked')) {
          var child = $(this).data('child');
          var item = $(this).data('item');
          var butt = '#' + item + ' .btn--with-arrow';
          var childwrap = '#' + item + ' .child-item_wrap label';
          var childitem = '#' + item + ' .child-item_wrap .custom-radio-btn .child__butt';
          var foot = '#' + item + ' .experience-content__footer';

          if (child == 'no') {
            var url = $(this).data('url');
            $(butt).attr('href', url);
            $(foot).removeClass('notvisible');
            $(childwrap).addClass('notvisible');
            $(childitem).prop('checked', false);
          } else {
            $(butt).attr('href', '#');
            $(foot).addClass('notvisible');
            var citem = $(this).data('child-item');
            var cla = '#' + item + ' .child-item_wrap .' + citem;
            $(childitem).prop('checked', false);
            $('.child-item_wrap .custom-radio-btn ').addClass('notvisible');
            $(cla).removeClass('notvisible');
          }
        }
      });
      $('.child__butt').click(function() {
        if ($(this).is(':checked')) {
          var item = $(this).data('item');
          var butt = '#' + item + ' .btn--with-arrow';
          var foot = '#' + item + ' .experience-content__footer';
          var url = $(this).data('url');
          $(butt).attr('href', url);
          $(foot).removeClass('notvisible');
        }
      });
    }

    //search box hide funcation
    $('body').click(function(e) {
      if (e.target.id == 'header__serach__box' || e.target.id == 'wp-block-search__input-1' || e.target.id == 'serach__box__item' || $(e.target).parents('#search__icon').length) {
      } else {
        if ($('#header__serach__box').hasClass('active')) {
          $('#header__serach__box').removeClass('active');
        }
      }
    });

    //mailto open in new tab
    $('.mailto').click(function(e) {
      e.preventDefault();
      var url = $(this).attr('href');
      window.open(url);
    });

    // Display from kitchen slider product specific
    if ($('.fromkit').length) {
      const url = new URL(window.location.href);
      const lastPart = url.pathname.split('/').pop();
      const versionSelector = '.' + lastPart;

      // Unslick existing slider
      $('.slider-sec1').slick('unslick');

      // Remove slides that don't match the current version
      $('.slider-sec__slide-item')
        .not(versionSelector)
        .remove();

      const remainingItems = $(versionSelector).length;

      let isInfinite = remainingItems > 1;
      let shouldHideTop = false;

      if (remainingItems === 0) {
        isInfinite = false;
        shouldHideTop = true;
      }

      if (shouldHideTop) {
        $('.ar__kit .slider-sec__top').hide();
      }

      // Reinitialize the slider with new settings
      $('.slider-sec1').slick({
        infinite: isInfinite,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '20vw',
        speed: 1000,
        autoplay: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              centerMode: false,
            },
          },
        ],
      });
    }

    //altering the hub spot submission button
    if ($('.subscribe-form__wrap')[0] && $('.hbspt-form')[0]) {
      var otarget = document.querySelector('.hbspt-form');
      var oobserver = new MutationObserver(function(mutations) {
        var data = $('.hbspt-form form .hs-submit .actions .hs-button').data('reactid');
        $('.hbspt-form form .hs-submit .actions .hs-button').after('<button data-reactid="' + data + '" class="rmbr btn btn--with-arrow" type="submit">Join the list</button>');
        $('.hbspt-form form .hs-submit .actions .hs-button').hide();
        oobserver.disconnect();
      });
      var oconfig = { attributes: true, childList: true, characterData: true };
      oobserver.observe(otarget, oconfig);
    }

    //calling product details using ajax call for landing page
    function render_product_details(title, data, type = 'half') {
      if (data) {
        var html = '<div class="details-item ' + type + '"><span class="details-title">' + title + '</span><p>' + data + '<p></div>';
        $('.prodread .pruduct-details-sec__details').append(html);
      }
    }
    if ($('.product__land__repeat')[0]) {
      $('.product__land__repeat').each(function(index) {
        $('.prodread').removeClass('prodread');
        $(this).addClass('prodread');
        const tenant = 'rombauer-vineyards';
        const apiUrl = 'https://api.commerce7.com';
        var slug = $(this).data('pslug');
        const marketingUrl = slug;
        if (slug) {
          $.ajax({ async: false, url: `${apiUrl}/v1/product-for-web/${marketingUrl}`, headers: { tenant } }).done((product) => {
            var image = product.image;
            var title = product.title;
            var content = product.content;
            var metadetails = product.metaData;

            var appellation = metadetails['appellation'];
            var harvested = metadetails['harvested'];
            var alcohol = metadetails['alcohol'];
            var cooperage = metadetails['cooperage'];
            var release = metadetails['release-date'];
            var composition = metadetails['varietal-composition'];
            var average = metadetails['average-brix-at-harvest'];
            var pdf = metadetails['tasting-notes-pdf-link'];

            if (image) {
              $('.prodread .pruduct-details-sec__image-sec figure img').attr('src', product.image);
            }
            if (title) {
              $('.prodread .pruduct-details-sec__title-sec h2').text(product.title);
            }
            render_product_details('Release Date', release);
            render_product_details('Appellation', appellation);
            render_product_details('Harvested', harvested);
            render_product_details('Varietal Composition', composition);
            render_product_details('Average Brix At Harvest', average);
            render_product_details('Alcohol', alcohol);
            render_product_details('Cooperage', cooperage, 'full');

            if (pdf) {
              var link = '<a target="_blank" class="rmbr btn btn--with-arrow js__link__pdf" download="" href="' + pdf + '">Download PDF</a>';
            }

            if (content) {
              $('.prodread .landing__notes__area .product-details-tasting .landing__full__content').append(content);
              $('.prodread .landing__notes__area .product-details-tasting .landing__full__content .extra-notes').remove();
              $('.prodread .landing__notes__area .product-details-tasting .landing__full__content').append(link);
            } else {
              $('.prodread .pruduct-details-sec__details').append(link);
              $('.prodread .landing__notes__area').remove();
            }

            //$('.prodread').removeClass('prodread');
          });
        }
      });
    }

    //Landing Hero Slider
    if ($('.js-landing-slider')[0]) {
      //$('.js-landing-slider').slick();
      $('.js-landing-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        appendDots: '.landing-slider-dots',
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        cssEase: 'ease-out',
        fade: true,
      });
    }
  },
};

export default pageElements;
